import { render, staticRenderFns } from "./solicitudCard.vue?vue&type=template&id=15ccb327&scoped=true"
import script from "./solicitudCard.vue?vue&type=script&lang=js"
export * from "./solicitudCard.vue?vue&type=script&lang=js"
import style0 from "./solicitudCard.vue?vue&type=style&index=0&id=15ccb327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccb327",
  null
  
)

export default component.exports